import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomTextField from "../../../Components/CustomTextField/CustomTextField";
import CustomSubmitButton from "../../../Components/CustomSubmitButton/CustomSubmitButton";
import Constant from "../../../Utils/Constant";
import LOGIN_BG from '../../../Assets/Images/login_bg.webp';
import { useDispatch } from "react-redux";
import { FORGOT_PASSWORD } from "../../../Redux/Slices/AuthSlices/Auth.action";
import { toast } from "react-toastify";
const ForgotPassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const formik = useFormik({
        initialValues: {
            email: "",
        },
        validationSchema: Yup.object().shape({
            email: Yup.string().required("Email Address Is Required!").matches(Constant.REGEX.EMAIL, "Please Provide Valid Email Address!"),
        }),
        onSubmit: async (values, { resetForm }) => {
            setIsLoading(true);
            await dispatch(FORGOT_PASSWORD({ email: values.email }))
                .unwrap()
                .then((res) => {
                    if (res && res.s === 1) {
                        resetForm();
                        toast.success(res?.m);
                        setIsLoading(false);
                    } else {
                        toast.error(res?.m);
                        setIsLoading(false);
                    }
                })
                .catch((error) => {
                    toast.error("Registration failed. Please try again.");
                    setIsLoading(false);
                });
        },
    });
    return (
        <>
            <Box
                sx={{
                    backgroundImage: `url(${LOGIN_BG})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100% 100%",
                }}
            >
                <Box
                    sx={{
                        width: "100%",
                        minHeight: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        py: 2,
                    }}
                >
                    <Box
                        sx={{
                            width: { xs: "95%", sm: "60%", md: "50%", lg: "40%", xl: "30%" },

                        }}
                    >
                        <Box
                            sx={{
                                width: "100%",
                                backgroundColor: '#fff',
                                borderRadius: "30px",
                                py: 1,
                                position: "relative",
                                zIndex: "3",
                                boxShadow: '0px 4px 20.8px 0px #00000040',
                                opacity: 1
                            }}
                        >
                            <Box sx={{ height: "100%", width: "100%", p: 3 }}>
                                <Typography sx={{ fontSize: "26px", fontWeight: "600", color: 'rgba(0, 0, 0, 1)',fontFamily: "Outfit" }}>
                                    Forgot Password!
                                </Typography>
                                <Typography sx={{ fontSize: "16px", fontWeight: "400", color: 'rgba(0, 0, 0, 0.8)',fontFamily: "Outfit" }}>
                                    Provide your email to recover your password.
                                </Typography>

                                <form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        formik.handleSubmit();
                                        return false;
                                    }}
                                    style={{
                                        width: "100%",

                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "start",
                                        alignItems: "center",
                                        gap: "1rem",
                                        paddingTop: "30px",
                                    }}
                                >
                                    <Box sx={{ width: "100%" }}>
                                        <CustomTextField
                                            label="Email"
                                            type="text"
                                            placeholder="Enter your email address"
                                            name="email"
                                            value={formik.values.email}
                                            onBlur={formik.handleBlur}
                                            onKeyUp={formik.handleBlur}
                                            errors={formik.touched.email && formik.errors.email}
                                            onChange={(e) => {
                                                const { value } = e.target;
                                                if (value.trimStart() !== value) {
                                                    e.target.value = value.trimStart();
                                                }
                                                formik.handleChange(e);
                                            }}
                                        />
                                    </Box>
                                    <Box
                                        sx={{
                                            width: "55%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <CustomSubmitButton
                                            btnTitle="Forgot Password"
                                            loading={isLoading}
                                            type="submit"
                                        />
                                    </Box>
                                </form>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    );
};

export default ForgotPassword;
